import "core-js/modules/es.array.map.js";
import React from 'react';
import { Box, Flex, List, Text } from '@applyboard/crystal-ui';
import { consts } from "../utils";
import { PageSectionTitle } from "../PageSectionTitle";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ScholarshipEligibleLevels = function ScholarshipEligibleLevels(_ref) {
  var eligibleLevels = _ref.eligibleLevels;
  var hasEligibleLevels = !!eligibleLevels && eligibleLevels.length > 0;
  return _jsxs(Flex, {
    direction: "column",
    gap: 2,
    children: [_jsx(PageSectionTitle, {
      title: "Eligible program levels"
    }), hasEligibleLevels ? _jsx(Box, {
      pl: 4,
      children: _jsx(List, {
        children: eligibleLevels.map(function (level) {
          return _jsx(List.Item, {
            children: level
          }, level);
        })
      })
    }) : _jsx(Text, {
      children: consts.allProgramLevelsEligible
    })]
  });
};